/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  UPDATE_PACKAGES,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const updatePackagesAction = createAction(UPDATE_PACKAGES)

/**
 * Export
 */
export const updatePackages = (value) => async (dispatch) => {
  try {
    dispatch(updatePackagesAction(value))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/packages.js